import React, { useEffect, useState } from 'react';
import classes from "./Dashboard.module.css";
import Nav from "./../Nav/hmdn"
import Ftr from "./../Footer/Ftr"
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import {Link} from 'react-router-dom'
axios.defaults.withCredentials=true;

const Dashboard = () => {
  const [userProfile, setUserProfile] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await axios.get('https://infisea.com/admindashboard');
        setUserProfile(response.data);
      } catch (error) {
        console.error('Error fetching user profile:', error);
        // Handle error as needed
      }
    };

    fetchUserProfile();
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post('https://infisea.com/logout');
      Cookies.remove('userPrimaryKey');
      alert('Logout successful');
  
      window.location.href = '/login';
    } catch (error) {
      console.error('Error during logout:', error);
      // Handle error as needed
    }
  };

/*
  // Check session status every 5 minutes (adjust the interval as needed)
  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await axios.get('https://infisea.com/session');
        const isAuthenticated = response.data.isAuthenticated;

        if (!isAuthenticated) {
          // Session expired, perform logout
          handleLogout();
        }
      } catch (error) {
        console.error('Error checking session status:', error);
      }
      
    };
const sessionCheckInterval = setInterval(checkSession, 10 * 1000); // Check every 10 seconds
    //const sessionCheckInterval = setInterval(checkSession, 5 * 60 * 1000);

    // Clear the interval on component unmount
    return () => clearInterval(sessionCheckInterval);
  }, []);


  if (!userProfile.id) {
    // Redirect to login if user is not authenticated
    navigate('/login');
    return null;
  }

*/

  
  return (
     <div>
            <Nav/> <br/><br/><br/>
<div className={classes.buttoms}>

{userProfile ? (
        <div>
          <p>ID: {userProfile.id}</p>
          <p>Name: {userProfile.name}</p>
          <p>Email: {userProfile.email}</p>
          <p>Mobile Number: {userProfile.mobno}</p>
          <p>Unique Id : {userProfile.aid}</p>
        </div>
      ) : (
        <p> <br/><br/><br/>Loading...</p>
      )}



<Link to= "/Addproduct"><button className={classes.button}> ADD PRODUCT </button></Link>
<Link to= "/Viewproduct"><button className={classes.button}> VIEW / REMOVE PRODUCT </button></Link>
<Link to= "/Updateadminprofile"><button className={classes.button}> UPDATE PROFILE </button></Link>
<button onClick={handleLogout} className={classes.button}>LOGOUT</button>



    </div>
          <Ftr/>
     </div>
  )
}

export default Dashboard